<ft-modal-editor-wrapper [canSave]="!disabled">
    <ng-template #triggerTmpl>
        <ng-content></ng-content>
    </ng-template>
    <div class="ft2-input -large v-center h-between">
        <label>{{label}}</label>
        <mat-slide-toggle [name]="name" [(ngModel)]="value" [required]="required" #control="ngModel" [disabled]="disabled"></mat-slide-toggle>
    </div>
</ft-modal-editor-wrapper>
